<template>
  <transition :enter-active-class="enterActClass ? 'animated ' + enterActClass : ''" :leave-active-class="leaveActClass ? 'animated ' + leaveActClass : ''">
    <div class="transition-box" v-if="show">
      <slot></slot>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'BaseTransition',
  props: {
    // 使用第三方动画库
    // 进入动画名
    enterActClass: String,
    // 离开动画名
    leaveActClass: String,
    // 控制动画
    show: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped></style>
